import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import VerificationPhoneNumber from 'components/components/common/VerificationPhoneNumber';
import { setBookingUserData } from 'components/actions/bookingActions';
import { setUserLogged } from 'components/actions/authActions'
import BookingRedirect from 'components/components/booking/utils/BookingRedirect';
import StepHeader from '../../common/StepHeader';
import TransHelper from 'components/common/translations/TransHelper';

class UserConfirmPhone extends Component {

  trans = (key) => {
    return TransHelper.translate(this.props.locale, "content.userData." + key);
  }

  componentDidMount() {
    new BookingRedirect(this.props).canViewUserPhoneVerification();
  }

  render() {
    return (
      <div className="content" style={{ padding: 0 }}>
        <div className="grid-layout grid-layout--vh">
          <div className="grid-layout__item grid-layout__item--desc grid-layout__item--middle" style={{ overflow: 'hidden' }}>
            <div className="content__desc content__desc--static">
              <StepHeader
                link="routes.url.userData"
                linkTitle={this.trans('backToPersonalData')}
                step="4"
                title={this.trans('personalData')}
                isAnim={true}
                booking
              />

              <div className="booking-verify-phone">
                <VerificationPhoneNumber
                  isBooking={true}
                  customerData={this.props.userData}
                  setBookingUserData={this.props.setBookingUserData}
                  setUserLogged={this.props.setUserLogged}
                />
              </div>
            </div>
          </div>
          <div className="grid-layout__item grid-layout__item--info" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    userData: state.booking.userData,
    isLogged: state.app.isLogged,
    departureAddress: state.booking.departureAddress,
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { setBookingUserData, setUserLogged }
  )(UserConfirmPhone)
);